import { ChangeEvent, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import '../reportStyles.scss';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { CustomButton, CustomCheckBox } from '../../../shared/uiComponents';
import { ReportFilters } from '../helpers';
import { REPORT_GENERATION_MESSAGE } from '../../../shared/Helpers/constants';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getClientReports } from '../../../redux/State/exportSlice';

const DownloadSoapNotes = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const [includeTrials, setIncludeTrials] = useState<boolean>(false);

	const filterData = useSelector((state) => state.billing.billingFilters);
	const loading = useSelector((state) => state.export.loading);

	const downloadHandler = useCallback(() => {
		const { clientId, startDate, endDate } = filterData;

		if (!clientId || !startDate || !endDate) return;

		toast(REPORT_GENERATION_MESSAGE);

		dispatch(
			getClientReports({
				clientId,
				startDate,
				endDate,
				includeTrials,
			}),
		)
			.then(unwrapResult)
			.then((response) => {
				const objectURL = URL.createObjectURL(response);
				const link = document.createElement('a');
				link.href = objectURL;
				link.setAttribute('download', `SOAP note ${startDate} - ${endDate}.zip`);
				document.body.appendChild(link);
				link.click();
			})
			.catch(errorNormalizer);
	}, [dispatch, includeTrials, filterData]);

	const includeTrialsHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIncludeTrials(checked);
	};

	return (
		<>
			<ReportFilters showUsers={false} showOnlyNew={false} />
			<div style={{ display: 'flex', maxWidth: '720px', gap: '16px' }}>
				<CustomCheckBox
					item={{
						label: 'Include Trials',
						id: '0',
						checked: includeTrials,
						disabled: loading,
					}}
					onChange={includeTrialsHandler}
				/>
				<CustomButton
					title="Download"
					onClick={downloadHandler}
					loading={loading}
					disabled={!filterData.clientId || filterData.timeError}
				/>
			</div>
		</>
	);
};

export default DownloadSoapNotes;
